import { Pipe, PipeTransform } from '@angular/core';
import { formatSSN } from './ssn-format.utils';

@Pipe({
  name: 'formatSsn',
  standalone: true,
})
export class SsnFormatterPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value == null) {
      return '';
    }

    return formatSSN(value.toString());
  }
}
